import store from '@/store';

export default (to, from, next) => {
  // TODO: clear session here?
  if (!store.getters['account/isAuthenticated']) {
    next('/login');
  } else {
    next();
  }
};
